"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable import/no-cycle */
__export(require("./core"));
__export(require("./to_locale_string"));
/**
 * Check if a formatting number with unit is supported
 * @public
 * @param unit unit to check
 */
function isUnitSupported(unit) {
    try {
        new Intl.NumberFormat(undefined, {
            style: 'unit',
            // @ts-ignore
            unit: unit,
        });
    }
    catch (e) {
        return false;
    }
    return true;
}
exports.isUnitSupported = isUnitSupported;
//# sourceMappingURL=index.js.map